// extracted by mini-css-extract-plugin
module.exports = {"badge":"checks_badge__2RCgr"};